export const TNames = {
    JournalActivityChanged: 'JournalActivityChanged',
    Minute: 'Minute',
    logged: 'Logged',
    dayLoaded: 'dayLoaded',
    clientDataChanged: 'clientDataChanged',
    documentClick: 'documentClick',
}